let module = angular.module('app.resources');

module.factory('RokuApp', ($resource) => {
  'ngInject';

  return $resource(
    `${API_ROOT}/account/roku_apps/:id`,
    { id: '@id' },
    {
      update: {
        method: 'PUT',
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/roku_app.js